import { FilterObject } from '../../../shared/models/FilterBarObject';
import { ReportMenuItem } from '../../models/reports/reports.interface';

export class GetReport {
  static type = '[Reports] Get Report';

  constructor(public reportType: string, public args: any) {
  }
}

export class SelectReportMenuItem {
  static type = '[Reports] Select Report Menu Item';

  constructor(public reportItem: ReportMenuItem) {
  }
}

export class SetSelectedReportFilter {
  static type = '[Reports] Set Selected Report Filter';

  constructor(public filterObj: FilterObject<any>) {
  }
}


export class GetReportsConfiguration {
  static type = '[Reports] Get Reports Configuration';

  constructor() {
  }
}
